// extracted by mini-css-extract-plugin
export default {"no_gap_top":"InfoHeader_no_gap_top__+t9XU","py_05":"InfoHeader_py_05__946V6","no_gap_bottom":"InfoHeader_no_gap_bottom__vTd6f"};